export const IsAlreadySellingOptions = [
  {
    id: 'yes',
    name: 'txt_yes',
  },
  {
    id: 'no',
    name: 'txt_no_not_yet',
  },
];
